const componentModal = () => {
	const modalLinks = document.querySelectorAll(".slidermitglieder__link");
	const modal = document.querySelector(".modal");
	const modalClose = document.querySelector(".modal-close");
	const modalContents = document.querySelectorAll(".modal-content");
	const modalCloseButtons = document.querySelectorAll(".btn-modal-close");
	const body = document.body;

	modalLinks.forEach((modalLink) => {
		modalLink.addEventListener("click", (e) => {
			e.preventDefault();

			openModal();

			modalContents.forEach((modalContent) => {
				if (modalContent.getAttribute("data-id") === modalLink.id) {
					modalContent.style.display = "block";

					// const modalContentVideo = modalContent.querySelector("video");
					// modalContentVideo.currentTime = 0;
					// modalContentVideo.play();
				}
			});
		});
	});

	modalClose.addEventListener("click", () => {
		closeModal();
	});

	modal.addEventListener("click", (e) => {
		if (e.target.classList.contains("modal")) {
			closeModal();
		}
	});

	modalCloseButtons.forEach((modalCloseButton) => {
		modalCloseButton.addEventListener("click", () => {
			closeModal();
		});
	});

	const openModal = () => {
		modal.style.display = "block";
		body.style.overflow = "hidden";
		modal.scrollTop = 0;

		// const modalVideos = document.querySelectorAll("video");
		// modalVideos.forEach((modalVideo) => {
		// 	modalVideo.pause();

		// 	const poster = modalVideo.poster;
		// 	const posterChange = poster.substring(poster.length - 3, 0);
		// 	if (posterChange.includes("jpg?h=")) {
		// 		modalVideo.poster = posterChange + "1080";
		// 	}
		// });
	};

	const closeModal = () => {
		modal.style.display = "none";
		body.style.overflow = "";

		modalContents.forEach((modalContent) => {
			modalContent.style.display = "none";
		});

		// const modalVideos = document.querySelectorAll("video");
		// modalVideos.forEach((modalVideo) => {
		// 	modalVideo.pause();
		// });

		const startVideos = document.querySelectorAll(".video-header");
		startVideos.forEach((startVideo) => {
			const videoStart = startVideo.querySelector("video");
			videoStart.play();
		});
	};

	// const modalVideos = document.querySelectorAll("video");
	// modalVideos.forEach((modalVideo) => {
	// 	modalVideo.pause();
	// });
};

export default componentModal;
